angular.module('offlineChecker')
    .filter('unitReportingGroupFilter', unitReportingGroup);

function unitReportingGroup() {
    return function (reservations, unitIdIndex, unitReportingGroups, filteringOnGroup) {
        if (!Array.isArray(reservations)) {
            return reservations;
        }
        if (reservations.length === 0) {
            return reservations;
        }
        if (unitIdIndex >= reservations[0].length) {
            return reservations;
        }
        if (!(unitIdIndex >= 0)) {
            return reservations;
        }
        if (!filteringOnGroup) {
            return reservations;
        }
        var out = [];
        angular.forEach(unitReportingGroups, function (reportingGroup) {
            if (reportingGroup.id === filteringOnGroup) {
                angular.forEach(reservations, function (reservation) {
                    if(reportingGroup.units.indexOf(reservation[unitIdIndex]) >= 0){
                        out.push(reservation);
                    }
                });
            }
        });
        return out;
    };
}
